<ng-container *ngIf="saseung3">
  <app-hanja-content [hanjas]="saseung3.hanja"
                     [hangul]="saseung3.hangul"
                     [firstHun]="firstHun"></app-hanja-content>

  <div class="info-box">
    <div class="hun-box">
      <span *ngFor="let tone of getFourTonesArray()"
            class="label-txt">{{ GetSaseungTxt(tone) }}성</span>
      <span class="first-hun"
            [innerHTML]="firstHun | resize | keepHtml"></span>
      <b *ngIf="showHangul" class="hangul">&nbsp;{{ saseung3.hangul }}</b>
    </div>
    <div *ngIf="restHun"
         class="rest-hun"
         [innerHTML]="restHun | resize | keepHtml"></div>
  </div>

  <article *ngIf="showBookmarkButton" class="bookmark-btn-box">
    <button type="button"
            class="bookmark-btn {{ getBmCss(saseung3) }}"
            [attr.aria-label]="saseung3.bookmark ? '책갈피 해제' : '책갈피 추가'"
            (click)="ToggleBookmark($event)"></button>
  </article>
</ng-container>
